import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteusermappingService {
  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  
  ESS_UserWiseSiteRightsSelect(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `ESS_UserWiseSiteRights/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_UserWiseSiteRightsInsertUpdate(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `ESS_UserWiseSiteRights_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
